const Config = {
  236: {
    platformApi: "http://192.168.16.236:5000",
    apiRoot: "http://192.168.16.236:5000",
    staticUrl: "http://dev-cdn.xdp.xi-life.cn/",
    assertUrl: "http://dev-cdn.xdp.xi-life.cn/",
    loginUrl: "http://192.168.16.236",
    eshopUrl: "http://192.168.16.236:5555/product/detail?detailId=",
    shopUrl: "http://192.168.16.236:5555",
    environment: "236",
  },
  prod: {
    platformApi: "https://apic.xdp.xi-life.cn",
    apiRoot: "https://apic.xdp.xi-life.cn",
    staticUrl: "https://cdn.xique.com/",
    assertUrl: "https://cdn.xique.com/",
    loginUrl: "http://192.168.16.175",
    eshopUrl: "https://mall.xique.com/product/detail?detailId=",
    shopUrl: "https://mall.xique.com/",
    environment: "prod",
  },
};

const REACT_APP_NODE_ENV = process.env.REACT_APP_NODE_ENV;

const config = Config[REACT_APP_NODE_ENV];
export default config;
